<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-form-file
        multiple
        @change="change"
        placeholder="Selecciona o arrastra un archivo"
        drop-placeholder="Suelta el archivo aquí"
    ></b-form-file>

    <div v-if="enviando" class="text-center">
      <h3>Cargando por favor espere...</h3>
      <b-spinner variant="primary" label="cargando"></b-spinner>
    </div>
    <div v-else-if="archivosNativos.length === 0" class=" mt-5 alert alert-info"> No se han seleccionado archivos</div>
    <table v-else class="table mt-5 table-sm table-default table-bordered table-striped">
      <thead>
      <tr class="table-b-table-default">
        <th>
          Nombre
        </th>
        <th>
          Tamaño
        </th>
        <th>
          Tipo
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="archivoNativo in archivosNativos" :key="archivosNativos.indexOf(archivoNativo)">
        <td>
          {{ archivoNativo.name }}
        </td>
        <td>
          {{ (archivoNativo.size / (1024 * 1024)).toFixed(3) }} Mb
        </td>
        <td>
          {{ archivoNativo.type }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import {NativeArchivoDto} from "../../apiServices/dto/archivo/NativeArchivoDto";
import {ArchivoService} from "../../apiServices/archivo/ArchivoService";
import moment from "moment";
import {MovimientoService} from "@/apiServices/movimiento/MovimientoService";

export default {
  name: "SubirArchivo",
  components: {},
  props: {
    padre: String,
    paciente: Number,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    archivosNativos: [],
    archivoService: new ArchivoService(),
    movimientoService: new MovimientoService(),
    enviando: false,
    urlMovimiento: false,
  }),
  mounted() {
    this.archivosNativos = [];
    this.archivosGuardados = [];
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.movimientoService.obtenerUrlMovimiento().then((r) => {
      let fecha = moment(new Date()).utc().format("YYYY-MM-DD");
      let url = r;
      this.urlMovimiento = url.replace('#id_paciente',this.paciente) +"/"+ this.padre + "/"+  fecha;
    });
  },
  methods: {
    change(e){
      const file = e.target.files || e.dataTransfer.files;
      this.nuevoArchivo(file)
    },
    nuevoArchivo(file) {
      file.forEach(f => {
        this.enviando = true;
        this.archivoService.seleccionarArchivoYEnviar(f, this.urlMovimiento, this.paciente).then((r)=> {
          this.archivosNativos.push(new NativeArchivoDto(f));
          this.archivosGuardados.push(r)
          this.$emit('archivo',r)
          this.enviando = false;
        })
      })
    }
  },

}
</script>
<style scoped>
.table-b-table-default {
  color: #ffffff !important;
  background-color: #0e6ba9 !important;
}
</style>
